<div class="tenant-management">
  <div class="tenant-management-container">
    <nz-layout class="inner-layout">
      <nz-sider nzWidth="15%" [nzCollapsed]="isCollapsed">
        <ul nz-menu nzMode="inline" class="sider-menu">
          @for (m of this.menuData?.childModules; track m) {
          <li nz-menu-item [ngClass]="{
                'single-menu': true,
                'single-menu-collapse': isCollapsed,
                '': !isCollapsed,
              }" [nzSelected]="m.id == selectedOption" (click)="clickItem(m)">
            <span nz-icon [nzType]="'icons:' + m.icon" [ngClass]="{
                  'single-menu-icon': isCollapsed,
                  'single-menu-icon-nc': !isCollapsed
                }"></span>
            <span [ngClass]="{ 'label-single': isCollapsed, '': !isCollapsed }">{{ m.name | translate }}</span>
          </li>
          }
        </ul>
      </nz-sider>
      <nz-content class="inner-content" [ngClass]="isCollapsed ? 'inner-content-collapse' : 'inner-content'">

        <button nz-button class="collapse-menu" (click)="toggleCollapsed()">
          @if (!isCollapsed) {
          <mat-icon class="collapse-menu-icon">keyboard_arrow_left</mat-icon>
          }
          @if (isCollapsed) {
          <mat-icon class="collapse-menu-icon">keyboard_arrow_right</mat-icon>
          }
        </button>

        @if (activeSubmenu() == componentPaths.userManagement) {
        <app-user-management></app-user-management>
        }
        @if (activeSubmenu() == componentPaths.careTeamTemplates) {
        <app-care-team-management></app-care-team-management>
        }
      </nz-content>
    </nz-layout>
  </div>
</div>
